/**
 * Boot-time custom-domain resolution.
 *
 * On `app.foxet.ai` (and localhost) this does nothing and the app boots as the
 * normal dashboard. On any other host it asks the API which tenant/product the
 * host belongs to, ONCE, before React mounts — the answer decides the whole
 * route table, so resolving it after mount would flash the dashboard at a
 * prospect first.
 *
 * FAIL CLOSED. `tenantSlug: null` (unknown host, unverified domain, API down,
 * malformed response) sends the visitor to the Foxet landing. There is no
 * best-effort guess: showing tenant A's demo on tenant B's domain is the
 * failure this whole path exists to prevent.
 */
import { isPlatformHost, type DomainContext } from '@foxet/shared';
import { fetchDomainContext } from './api/domains';

export const FOXET_LANDING_URL = 'https://foxet.ai';

let resolved: DomainContext | null = null;

/**
 * The resolution for THIS origin, or null when we are on a platform host.
 * Synchronous — `resolveHostContext()` has already awaited by the time any
 * component can call this.
 */
export function getDomainContext(): DomainContext | null {
  return resolved;
}

export async function resolveHostContext(): Promise<DomainContext | null> {
  if (typeof window === 'undefined') return null;
  const host = window.location.host;
  if (isPlatformHost(host)) return null;
  resolved = await fetchDomainContext(host);
  return resolved;
}
